import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// helpers
import get from 'lodash.get';

function PdpSharedDetailMeasurement({ dataTn, measurements }) {
    const inch = measurements.find(dim => dim.unit === 'IN');
    const cm = measurements.find(dim => dim.unit === 'CM');
    const inchValue = get(inch, 'value');
    const cmValue = get(cm, 'value');

    if (!inchValue && !cmValue) {
        return null;
    }
    return (
        <span data-tn={dataTn}>
            <div>
                <span>{`${inchValue} (${cmValue})`}</span>
            </div>
        </span>
    );
}

PdpSharedDetailMeasurement.propTypes = {
    dataTn: PropTypes.string.isRequired,
    measurements: PropTypes.array.isRequired,
};

export default createFragmentContainer(PdpSharedDetailMeasurement, {
    measurements: graphql`
        fragment PdpSharedDetailMeasurement_measurements on ItemDisplayMeasurementType
            @relay(plural: true) {
            unit
            value
        }
    `,
});
